import {ReactElement, useContext, useRef, useState} from "react";
import {ListJobs, ListJobsDisplayColumn, ListJobsRef} from "./ListJobs";
import {JobType} from "../../../__generated__/generated_types";
import {AdminWrapper} from "../AdminWrapper";
import {SendBudgetForm} from "./SendBudgetForm";
import {Button} from "@zendeskgarden/react-buttons";
import {ReactComponent as IconReload} from '@zendeskgarden/svg-icons/src/16/reload-fill.svg';
import AdminHeader from "../AdminHeader";
import * as css from "./styles/SendBudget.module.scss";
import { useChartOfAccounts } from "../../../contexts/chartofaccounts/ChartOfAccountsContext";
import { getBudgetYearForProperty, useProperties } from "../../../contexts/properties/PropertiesContext";
import {AuthContext} from "../../../contexts/AuthContext";
import {Tab, TabList, TabPanel, Tabs} from "@zendeskgarden/react-tabs";

enum SendPmsDataTabs {
    Budget = "budget",
    Reforecast = "reforecast",
}

export function SendBudget(): ReactElement {
    const coa = useChartOfAccounts();
    const properties = useProperties();
    const auth = useContext(AuthContext);
    const listJobsRef = useRef<ListJobsRef>(null);
    const [selectedTab, setSelectedTab] = useState<string>(SendPmsDataTabs.Budget);
    const budgetYear = getBudgetYearForProperty(properties.currentProperty, auth.budgetYear);

    return <AdminWrapper>
        <AdminHeader title="Send Budget to PMS" subtitle="Create and monitor jobs that send your budget to your property management system." />
        <Tabs selectedItem={selectedTab} onChange={setSelectedTab}>
            <TabList>
                <Tab item={SendPmsDataTabs.Budget}>Budget</Tab>
                <Tab item={SendPmsDataTabs.Reforecast}>Reforecast</Tab>
            </TabList>
            <TabPanel item={SendPmsDataTabs.Budget}>
                <section className={css.section}>
                    <h4 className={css.sectionHeader}>Create Job</h4>
                    <SendBudgetForm submitted={() => listJobsRef.current?.reload()} budgetYear={budgetYear}/>
                </section>
            </TabPanel>
            <TabPanel item={SendPmsDataTabs.Reforecast}>
                <section className={css.section}>
                    <h4 className={css.sectionHeader}>Create Job</h4>
                    <SendBudgetForm submitted={() => listJobsRef.current?.reload()} budgetYear={budgetYear} isReforecast/>
                </section>
            </TabPanel>
        </Tabs>
        <section className={css.section}>
            <div className={css.compoundSectionHeader}>
                <h4 className={css.sectionHeader}>Jobs List</h4>
                <Button style={{height: "23px"}} isLink onClick={() => listJobsRef.current?.reload()}>Refresh <IconReload /></Button>
            </div>
            {
                coa.chartOfAccountsFlat && properties.properties &&
                    <ListJobs
                        jobType={JobType.SendBudget}
                        ref={listJobsRef}
                        accounts={coa.chartOfAccountsFlat}
                        properties={properties.properties}
                        visibleColumns={[
                            ListJobsDisplayColumn.status,
                            ListJobsDisplayColumn.user,
                            ListJobsDisplayColumn.created,
                            ListJobsDisplayColumn.ended,
                            ListJobsDisplayColumn.details,
                            ListJobsDisplayColumn.errorMessage,
                        ]}
                    />
            }
        </section>
    </AdminWrapper>;
}
